import { useEffect } from "react";
import {
  NEWS_CONTENT_CLASS,
  NEWS_PAGE_DESCRIPTION,
  NEWS_PAGE_TITLE,
} from "../constants/news.constants";
import { conclaveArticle } from "../data/newsContent";
import { NewsArticleConclave } from "../components/NewsArticleConclave";
import { NewsArticleDelhi } from "../components/NewsArticleDelhi";
import { NewsArticlePm } from "../components/NewsArticlePm";
import { NewsBreadcrumb, NewsHero } from "../components/NewsHero";
import {
  NewsQuoteBar,
  NewsSubscribeCta,
  NewsThankYouBanner,
} from "../components/NewsSubscribeCta";
import { cn } from "@/lib/utils";

/**
 * News & Updates marketing page — hero, articles, highlights, subscribe CTA.
 * Site footer is provided by Layout.
 */
export default function NewsPage() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = NEWS_PAGE_TITLE;

    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content") ?? "";
    if (meta) meta.setAttribute("content", NEWS_PAGE_DESCRIPTION);

    return () => {
      document.title = prevTitle;
      if (meta) meta.setAttribute("content", prevDesc);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <NewsHero />
      <NewsBreadcrumb current={conclaveArticle.title} />

      <main className={cn(NEWS_CONTENT_CLASS, "pt-4 sm:pt-6 pb-16 sm:pb-20")}>
        <NewsArticleConclave />
        <NewsArticleDelhi />
        <NewsQuoteBar />
        <NewsThankYouBanner />
        <NewsArticlePm />
        <NewsSubscribeCta />
      </main>
    </div>
  );
}
